module.exports = ["/project/analog-clock"];
